<template>
  <div class="payCardMain">
    <div class="kakao_main">
      <div id="kakaodropin"></div>
    </div>
    <Dialog
      :visible.sync="paymentResultDialogVisible"
      :title="$t('pay.confirmTitle')"
      :cancelText="$t('pay.confirmUnpay')"
      :confirmText="$t('pay.confirmPaid')"
      :showClose="false"
      @confirm="handlePaid"
      @cancel="handleUnpaid"
      @touchmove.native.prevent
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AdyenCheckout from '@adyen/adyen-web'
import '@adyen/adyen-web/dist/adyen.css'
import { adyenLocaleMap } from '../../../tool/constant'
import { getorder, adyen_callback, adyen_payments_details, get_order_info } from '@/api/index.js'
import { isIPadOS26 } from '@/tool/utils'
import { getCallPaymentLimitTrackingProps } from '@/tool/packagePurchaseLimit'
import mixinCheckTaxExpires from '@/mixins/mixinCheckTaxExpires.js'
export default {
  name: 'kakao',
  props: ['payinfo', 'mount', 'pay_btn_style'],
  inject: ['newCheckPay'],
  mixins: [mixinCheckTaxExpires],
  data() {
    return {
      payis: true,
      cg_request_id: '',
      provider_order_id: '',
      payment_methods: [],
      client_key: '',
      loadingis: false,
      payinitis: false,
      checkout: null,
      waitingAction: false,
      paymentResultDialogVisible: false,
    }
  },
  computed: {
    ...mapState({
      gameId: (state) => state.app.gameId,
      userInfo: (state) => state.user.userInfo,
      loginType: (state) => state.user.loginType,
      userIpCountry: (state) => state.user.userIpCountry,
      isProductionTax: (state) => state.app.isProductionTax,
    }),
  },
  watch: {
    pay_btn_style() {
      this.order()
    },
  },
  created() {
    this.order()
  },
  mounted() {
    this.$store.commit('app/SET_IS_NO_SCROLL', true)
    document.removeEventListener('visibilitychange', this.visibilitychangefn)
    document.addEventListener('visibilitychange', this.visibilitychangefn)
  },
  beforeDestroy() {
    this.$store.commit('app/SET_IS_NO_SCROLL', false)
    document.removeEventListener('visibilitychange', this.visibilitychangefn)
  },
  methods: {
    visibilitychangefn() {
      if (!this.waitingAction) return
      if (document.visibilityState === 'hidden') {
        this.waitingAction = false
        this.showPaymentResultConfirm()
      }
    },

    showPaymentResultConfirm() {
      this.paymentResultDialogVisible = true
    },

    handlePaid() {
      get_order_info({ provider_order_id: this.provider_order_id })
        .then((response) => {
          const { order_status } = response.data.data || {}
          this.$parent.pay_submitis = false
          if (order_status === 1) {
            this.$parent.successpay(response.data.data)
          } else if (order_status === 2) {
            this.$parent.failpay(response.data)
          } else if (order_status === 3) {
            this.$parent.failpay({
              ...response.data,
              data: {
                ...(response.data.data || {}),
                fail_code: 'pay.limitPackBuyFail',
                uuid: this.provider_order_id,
              },
            })
          } else {
            this.$parent.close()
            this.$confirm({
              title: this.$t('pay.confirmNoResult'),
              content: this.$t('pay.confirmTips'),
              confirmText: this.$t('game.okbtn'),
              hideCancel: true,
              hideClose: true,
            })
          }
        })
        .catch((error) => {
          this.$parent.failpay(error)
          this.$parent.pay_submitis = false
          this.$rum.errorReport(error)
        })
    },
    handleUnpaid() {
      get_order_info({ provider_order_id: this.provider_order_id })
        .then((response) => {
          const { order_status } = response.data.data || {}
          this.$parent.pay_submitis = false
          if (order_status === 1) {
            this.$parent.successpay(response.data.data)
          } else if (order_status === 2) {
            this.$nextTick(() => {
              this.payinitis = false
              this.order()
            })
          } else if (order_status === 3) {
            this.$parent.failpay({
              ...response.data,
              data: {
                ...(response.data.data || {}),
                fail_code: 'pay.limitPackBuyFail',
                uuid: this.provider_order_id,
              },
            })
          } else {
            this.payinitis = false
            if (isIPadOS26()) {
              if (this.dropin) {
                this.dropin.unmount()
                this.dropin = null
              }
              this.checkout = null
            }
            this.ayden()
          }
        })
        .catch((error) => {
          this.$parent.failpay(error)
          this.$parent.pay_submitis = false
          this.$rum.errorReport(error)
        })
    },
    order() {
      if (this.pay_btn_style !== 'kakao') return
      if (this.payinitis) return

      if (!this.mixinCheckTaxExpires()) {
        return false
      }

      this.payinitis = true

      this.$parent.payment_log.report('web_payment_getorder_start')
      const params = {
        ...this.payinfo,
        user_id: this.userInfo.user_id,
        enter_type: this.loginType,
        bonus: this.$store.state.user.isFirst ? 1 : 0,
        taxed: this.isProductionTax,
      }
      const uid = this.$utils.customLocalStorage.getItem(
        `web_shopper_uid_${this.userInfo.user_uid}`
      )
      if (uid) {
        params.web_shopper_uid = uid
      }

      getorder(params)
        .then((res) => {
          //console.log(res)

          //校验黑名单之类的
          if (!this.newCheckPay(res)) {
            return false
          }

          if (res.data.code == 1) {
            this.cg_request_id = res.data.data.cg_request_id + ''
            this.provider_order_id = res.data.data.provider_order_id
            this.$utils.customSessionStorage.setItem(
              'provider_order_id',
              res.data.data.provider_order_id
            )
            this.$parent.updateProviderOrderId(res.data.data.provider_order_id)
            this.client_key = res.data.data.client_key

            //如果paysty 是ayden 则去掉卡卡哦
            if (this.payinfo.gateway == 75) {
              this.payment_methods = {
                ...res.data.data.payment_methods,
                paymentMethods: res.data.data.payment_methods.paymentMethods.filter(
                  (v) => v.type !== 'kakaopay'
                ),
              }
            } else {
              this.payment_methods = {
                paymentMethods: res.data.data.payment_methods.paymentMethods.filter(
                  (v) => v.type === 'kakaopay'
                ),
              }
            }

            // 缓存adyen uid
            if (res.data.data.web_shopper_uid) {
              this.$utils.customLocalStorage.setItem(
                `web_shopper_uid_${this.userInfo.user_uid}`,
                res.data.data.web_shopper_uid
              )
            }

            this.$parent.payment_log.set_properties({
              cg_request_id: this.provider_order_id,
            })
            this.$parent.payment_log.report('web_payment_getorder_success')

            this.$parent.payment_log.report('web_payment_sdkinit_start')
            this.ayden()
            this.payis = false

            this.$rum.report(
              'pay_sucess',
              {
                paystyle: 'ayden',
                type: 'getorder',
                response: res.data,
                prams: this.payinfo,
              },
              1
            )
          } else {
            this.$parent.failpay('Order failed！')

            this.$parent.payment_log.report('web_payment_getorder_fail', {
              code: 3,
              msg: res.data.msg ? res.data.msg : 'Order failed',
            })

            this.$rum.report(
              'pay_err',
              {
                paystyle: 'ayden',
                type: 'getorder',
                response: res.data,
                prams: this.payinfo,
              },
              3
            )
          }
        })
        .catch((error) => {
          console.log(error)
          this.payis = false
          this.$parent.payment_log.report('web_payment_getorder_error', {
            code: 2,
            msg: error,
          })
        })
    },
    cancel() {
      this.$parent.cancelpay()
      this.$parent.payment_log.report('web_payment_userpay_cancel')
    },
    async ayden() {
      const locale = adyenLocaleMap[this.$i18n.locale]
      const configuration = {
        paymentMethodsResponse: this.payment_methods,
        amount: this.mount,
        // paymentMethodsResponse: payment_methods,
        // amount:{value:9999,"currency": "USD"},
        clientKey: this.client_key,
        locale,
        environment: process.env.VUE_APP_STY, //生产环境需要更改为"live"
        onSubmit: (state, dropin) => {
          //不让其他支付框被点击
          this.$parent.pay_submitis = true

          this.loadingis = true

          var obj = {
            state_data: JSON.stringify(state.data),
            provider_order_id: this.provider_order_id,
            user_id: this.userInfo.user_id,
          }

          const taData = {
            iap_product_id: this.payinfo.product_id,
            payment_type: 'kakao', //添加kakao
            operator_type: 2,
            amount:
              this.isProductionTax && this.payinfo.taxed_price
                ? this.payinfo.taxed_price
                : this.payinfo.amount,
            currency: this.payinfo.currency,
            server_id: this.payinfo.user_extra_value,
            tid: this.provider_order_id,
            ...getCallPaymentLimitTrackingProps(this.$parent.pack),
            ...(this.$store.state.app.fromInstalledWebApp
              ? { open_ui_old: 'desktop_shortcut' }
              : {}),
          }
          if (this.gameId === '20195') {
            taData.iap_name = this.payinfo.data_name || ''
            taData.pkg_id = this.payinfo.pack_id || ''
            taData.reward = this.payinfo.reward || ''
          }
          this.$ta.track('call_payment', taData)

          this.$parent.payment_log.report('web_payment_userpay_success')
          this.$parent.payment_log.report('web_payment_verification_start')

          // console.log(state)
          // console.log(obj)

          adyen_callback(obj)
            .then((response) => {
              if (response.data.code == 1) {
                //Drop-in会自动根据这里拿到的action来处理/payments接口的响应
                if (response.data.data.action) {
                  this.waitingAction = true
                  if (
                    isIPadOS26() &&
                    response.data.data.action.type === 'redirect' &&
                    response.data.data.action.url
                  ) {
                    const a = document.createElement('a')
                    a.href = response.data.data.action.url
                    a.rel = 'noopener'
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                  } else {
                    dropin.handleAction(response.data.data.action)
                  }
                } else {
                  this.$parent.successpay(response.data.data)

                  this.$parent.payment_log.set_properties({
                    transaction_id: response.data.data.transaction_id
                      ? response.data.data.transaction_id
                      : '',
                  })
                  this.$parent.payment_log.report('web_payment_check_success')
                }
                this.loadingis = false
                this.$rum.report(
                  'pay_sucess',
                  {
                    paystyle: 'ayden',
                    type: 'onSubmit',
                    response: response,
                    prams: obj,
                  },
                  1
                )
              } else {
                let langKey = ''
                let uuid = ''
                if (response.data.code == 101031025) {
                  langKey = 'pay.limitPackBuyFail'
                  uuid = this.provider_order_id
                } else {
                  langKey = response.data.fail_code
                  uuid = response.data.uuid
                }
                this.$parent.failpay({
                  ...response.data,
                  data: {
                    ...(response.data.data || {}),
                    fail_code: langKey,
                    uuid: uuid,
                  },
                })
                this.loadingis = false
                this.$parent.pay_submitis = false

                this.$parent.payment_log.report('web_payment_check_fail', {
                  code: 3,
                  msg: response.data.msg ? response.data.msg : 'adyen_callback failed',
                })

                this.$rum.report(
                  'pay_err',
                  {
                    paystyle: 'ayden',
                    type: 'onSubmit',
                    response: response,
                    prams: obj,
                  },
                  3
                )
              }
            })
            .catch((error) => {
              console.log(error)
              this.$parent.failpay(error)
              this.loadingis = false
              this.$parent.pay_submitis = false
              this.$parent.payment_log.report('web_payment_check_error', {
                code: 2,
                msg: error,
              })

              this.$rum.errorReport(error)
              throw Error(error)
            })
        },
        onAdditionalDetails: (state, dropin) => {
          var obj = {
            details: JSON.stringify(state.data),
            provider_order_id: this.provider_order_id,
          }

          this.$parent.payment_log.report('web_payment_checkAgain_start')

          this.payis = true

          adyen_payments_details(obj)
            .then((response) => {
              if (response.data.code == 1) {
                this.$parent.successpay(response.data.data)

                this.$parent.payment_log.set_properties({
                  transaction_id: response.data.data.transaction_id
                    ? response.data.data.transaction_id
                    : '',
                })
                this.$parent.payment_log.report('web_payment_checkAgain_success')

                this.$rum.report(
                  'pay_sucess',
                  {
                    paystyle: 'ayden',
                    type: 'onAdditionalDetails',
                    response: response,
                    prams: obj,
                  },
                  1
                )
              } else {
                let langKey = ''
                let uuid = ''
                if (response.data.code == 101031025) {
                  langKey = 'pay.limitPackBuyFail'
                  uuid = this.provider_order_id
                } else {
                  langKey = response.data.fail_code
                  uuid = response.data.uuid
                }
                this.$parent.failpay({
                  ...response.data,
                  data: {
                    ...(response.data.data || {}),
                    fail_code: langKey,
                    uuid: uuid,
                  },
                })

                this.$parent.payment_log.report('web_payment_checkAgain_fail', {
                  code: 3,
                  msg: response.data.msg ? response.data.msg : 'adyen_payments_details failed',
                })

                this.$rum.report(
                  'pay_err',
                  {
                    paystyle: 'ayden',
                    type: 'onAdditionalDetails',
                    response: response,
                    prams: obj,
                  },
                  3
                )
              }
              this.loadingis = false
              this.$parent.pay_submitis = false
              this.payis = false
            })
            .catch((error) => {
              this.$parent.failpay(error)
              this.loadingis = false
              this.$parent.pay_submitis = false
              this.payis = false
              this.$parent.payment_log.report('web_payment_checkAgain_error', {
                code: 2,
                msg: error,
              })
              this.$rum.errorReport(error)
              throw Error(error)
            })
        },
        onError: (error) => {
          this.$rum.report(
            'pay_err',
            {
              paystyle: 'ayden',
              type: 'aydenerror',
              response: error,
              prams: {
                provider_order_id: this.provider_order_id,
              },
            },
            3
          )
          console.error('Failed to load Adyen Checkout SDK', error)
          console.log(error)
        },
        paymentMethodsConfiguration: {
          card: {
            //决定是否需要隐藏持卡人姓名输入框
            hasHolderName: true,
            //决定持卡人姓名输入框是否必填
            holderNameRequired: true,
            //决定是否需要隐藏绑卡勾选框
            enableStoreDetails: true,
            //若您在使用绑卡交易并且不需要买家输入CVC时(recurringProcessingModel=Subscription或UnscheduledCardOnFile)，您可将这里改成true来隐藏CVC输入栏，详情参考tokenization绑卡交易具体对接文档)
            hideCVC: false,
            //定义了前段展示的文案
            name: 'Credit or debit card',
          },
        },
      }
      //console.log(configuration)
      this.checkout = await AdyenCheckout(configuration)
      const dropin = this.checkout.create('kakaopay', {
        onReady: () => {
          console.log('Adyen Checkout SDK is onReady')
          this.$parent.payment_log.report('web_payment_sdkinit_success')
          this.$parent.payment_log.report('web_payment_userpay_start')
        },
        onError: (error) => {
          this.$parent.payment_log.report('web_payment_sdkinit_fail', {
            code: 2,
            msg: error,
          })
          console.error('Failed to load Adyen Checkout SDK', error)
          console.log(error)
        },
      })
      dropin.mount('#kakaodropin')
      this.dropin = dropin
      console.log(dropin)
    },
  },
}
</script>

<style lang="less" scoped>
.payCardMain {
  position: relative;
  width: 100%;
  height: 100%;
  .kakao_main {
    width: 100%;
    height: 100%;
  }
  #kakaodropin {
    width: 100%;
    height: 100%;
    ::v-deep(.adyen-checkout__spinner__wrapper) {
      display: none;
    }
    ::v-deep(.adyen-checkout__button__text) {
      font-size: 12px;
    }
  }
}
</style>
